import { getDefaultParam } from '../getDefaultParam.ts';

/**
 * Applies the given params to the URL.
 * @param url
 * @param params
 * @param getDefault Used if params does not contain a param
 * @example
 * applyParams('/path/{org}/{id}', { org: 'abc', id: '123' }, () => {})
 * // '/path/abc/123'
 */
export function applyParams(url: string, params: Record<string, string | number | undefined>,
  getDefault: (param: string) => string | number | undefined = getDefaultParam): string {
  return url.replace(/{([^}]+)}/g, (_, key) => {
    const value = params?.[key] ?? getDefault(key);

    if (value === undefined) {
      throw new Error(`Unknown param: ${key}. Known params: ${Object.keys(params).join(', ')}`);
    }

    return `${value}`;
  });
}